module.exports = __webpack_public_path__ + "static/media/Garanti.31ec0f8a.svg";